'use client';
import React from 'react';

export type BadgeSource =
  | 'PERPLEXITY' |'SERPAPI' |'CLAUDE' |'GEMINI' |'HUMAN';

const BADGE_CONFIG: Record<BadgeSource, {
  label: string;
  bg: string;
  text: string;
  border: string;
}> = {
  PERPLEXITY: {
    label: 'PERPLEXITY SOURCED',
    bg: '#0a1f12',
    text: '#00ff88',
    border: '#0f3320',
  },
  SERPAPI: {
    label: 'SERPAPI DATA',
    bg: '#0a1a2a',
    text: '#4db8ff',
    border: '#0f2a3a',
  },
  CLAUDE: {
    label: 'CLAUDE ESTIMATE',
    bg: '#1a1400',
    text: '#f5a623',
    border: '#2a2000',
  },
  GEMINI: {
    label: 'GEMINI ESTIMATE',
    bg: '#1a1000',
    text: '#ff9500',
    border: '#2a1800',
  },
  HUMAN: {
    label: 'NEEDS HUMAN CHECK',
    bg: '#1a0d0d',
    text: '#ff4d4d',
    border: '#2a0f0f',
  },
};

export const SourceBadge = ({
  source,
  size = 'sm',
  label,
}: {
  source?: BadgeSource;
  size?: 'xs' | 'sm';
  label?: string;
}) => {
  const config = BADGE_CONFIG[source ?? 'CLAUDE'] ?? BADGE_CONFIG.CLAUDE;
  return (
    <span
      style={{
        background: config.bg,
        color: config.text,
        border: `1px solid ${config.border}`,
        fontFamily: 'IBM Plex Mono, monospace',
        fontSize: size === 'xs' ? '8px' : '9px',
        fontWeight: 600,
        padding: size === 'xs' ? '1px 6px' : '2px 8px',
        borderRadius: '4px',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
        display: 'inline-block',
      }}
    >
      {label || config.label}
    </span>
  );
};

export default SourceBadge;
